<template>
  <v-dialog
    persistent
    :value="opened"
    width="400"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card block flat>
      <v-card-title class="saving-title">
        <v-layout column justify-center align-center pa-2>
          <v-progress-circular
            class="mb-3"
            indeterminate
            color="primary"
          ></v-progress-circular>
          Please wait while we are saving your changes...
        </v-layout>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SavingDialog',
  props: {
    opened: {
      type: Boolean,
    },
  },
};
</script>

<style lang="postcss" scoped>
.saving-title {
  font-size: 18px;
}
</style>
